import { render, staticRenderFns } from "./UpdateHealthScoreDialog.vue?vue&type=template&id=4417fbc0&"
import script from "./UpdateHealthScoreDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateHealthScoreDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports